// extracted by mini-css-extract-plugin
export var cardLayout = "_7c-1";
export var paginationContainer = "_7c-0";